import logInternalLinkClick from "lib/ga/internalLinkClick";
import AreaContainer from "../AreaContainer";
import styles from './destination.module.css';
import globalStyles from '../result.module.css';

interface Props {
    name: string;
    descMeta: string;
    uri: string;
    id: number;
}

const DestinationDisplay = ({ name, descMeta, uri, id }: Props) => {
    const ImageURL = (uri: string, format: string, width: string, retina: boolean = false) =>
        `/images/destinations/${uri}_hero-${width}${retina ? "@2x" : ""}.${format}`;
    return (
        <AreaContainer area="destination" style={null} extraClass={null}>
            <div className={styles.DestinationWrapper}>
                <h2 className={globalStyles.subTitleText}>About {name}</h2>
                <p className={globalStyles.mediumText}>{descMeta}</p>
                <div className={styles.destinationContainer}>
                    <figure>
                        <picture>
                            <source
                                media="(max-width: 500px)"
                                srcSet={`${ImageURL(uri, "webp", "h325")} 1x, ${ImageURL(
                                    uri,
                                    "webp",
                                    "h325",
                                    true
                                )} 2x`}
                                type="image/webp"
                            />
                            <source
                                srcSet={`${ImageURL(uri, "webp", "w740")} 1x, ${ImageURL(
                                    uri,
                                    "webp",
                                    "w740",
                                    true
                                )} 2x`}
                                type="image/webp"
                            />
                            <img
                                srcSet={`${ImageURL(uri, "jpg", "w740")} 1x, ${ImageURL(
                                    uri,
                                    "jpg",
                                    "w740",
                                    true
                                )} 2x`}
                                alt={name}
                                width="328"
                                height="217"
                                loading="lazy"
                            />
                        </picture>
                    </figure>
                    <div className={styles.destinationContent}>
                        <p className={`${globalStyles.mediumText} ${globalStyles.largeLineHeight} ${globalStyles.lightColorText}`} >{`We have a wide range of retail property and shops to let in ${name}, as well as a selection of shopping centres, retail parks and leisure schemes to increase the visibility of your brand.`}</p>

                        <a className={styles.destinationLink} href={`/destinations/${uri}`}
                            onClick={() => logInternalLinkClick(`/destinations/${uri}`, "Destination Tile", id)}
                        ><div className={globalStyles.mediumText} >{`Learn More About ${name}`}</div></a>

                        <a className={styles.destinationLink} href={`/shops-to-rent/${uri}`} 
                            onClick={() => logInternalLinkClick(`/shops-to-rent/${uri}`, "Destination Tile", id)}
                        ><div className={globalStyles.mediumText}>{`Search shops to rent in ${name}`}</div></a>

                    </div>
                </div>
            </div>
        </AreaContainer>
    )
}


export default DestinationDisplay;